import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/react";
import { useDisclosure } from "@heroui/react";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import { FaCopy } from "react-icons/fa";

interface InvitationLinkModalProps {
  disclosure: ReturnType<typeof useDisclosure>;
  invitationLink: string;
}

export function InvitationLinkModal({
  disclosure,
  invitationLink,
}: InvitationLinkModalProps) {
  const { isOpen, onOpenChange } = disclosure;

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="md"
      onClose={() => disclosure.onClose()}
    >
      <ModalContent>
        <ModalHeader>Приглашение создано</ModalHeader>
        <ModalBody className="pb-6">
          <div className="flex flex-col gap-2">
            <div className="text-sm text-foreground-500">
              Приглашение успешно создано. Скопируйте ссылку и отправьте её
              арендатору.
            </div>

            <Input
              value={invitationLink}
              readOnly
              variant="bordered"
              endContent={
                <CopyToClipboard
                  text={invitationLink}
                  onCopy={() => {
                    toast.success("Ссылка скопирована в буфер обмена!");
                  }}
                >
                  <Button
                    isIconOnly
                    variant="light"
                    size="sm"
                    className="min-w-unit-8">
                    <FaCopy />
                  </Button>
                </CopyToClipboard>
              }
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onPress={() => disclosure.onClose()}>
            Закрыть
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

